/* eslint-disable */
export interface CustomerBasicInformation {
    firstName: string;
    lastName: string;
    globalCustomerId: string;
    oktaId: string;
    coCustomerId: string;
    dateOfBirth: string;
    ssn: string;
    emailAddress: string;
    governmentIdType: string;
    governmentId: string;
    governmentIdIssuedState: string;
    salutation: string;
    middleInitial: string;
    suffix: string;
    racCoworker: string;
    dateOfBirthEnc: string;
    taxIdEnc: string;
    governmentIdEnc: string;
    verified: string;
    verifiedDate: string;
    isEditEnabled: boolean;
    addressLine1: string;
    addressLine2: string;
    state: string;
    city: string;
    zip: string;
    dateOfBirthDec: string;
    govtIdDecr: string;
    taxIdDecr: string;
}

const EMPTY_STRING = "";
const STRING_NO = "N";

export const BASIC_INFORMATION_TEMPLATE: CustomerBasicInformation = {
    firstName: EMPTY_STRING,
    lastName: EMPTY_STRING,
    globalCustomerId: EMPTY_STRING,
    coCustomerId: EMPTY_STRING,
    dateOfBirth: EMPTY_STRING,
    ssn: EMPTY_STRING,
    emailAddress: EMPTY_STRING,
    governmentIdType: EMPTY_STRING,
    governmentId: EMPTY_STRING,
    governmentIdIssuedState: EMPTY_STRING,
    salutation: EMPTY_STRING,
    middleInitial: EMPTY_STRING,
    suffix: EMPTY_STRING,
    racCoworker: EMPTY_STRING,
    dateOfBirthEnc: EMPTY_STRING,
    taxIdEnc: EMPTY_STRING,
    governmentIdEnc: EMPTY_STRING,
    verified: STRING_NO,
    verifiedDate: EMPTY_STRING,
    oktaId: EMPTY_STRING,
    isEditEnabled: false,
    addressLine1: EMPTY_STRING,
    addressLine2: EMPTY_STRING,
    state: EMPTY_STRING,
    zip: EMPTY_STRING,
    city: EMPTY_STRING,
    dateOfBirthDec: EMPTY_STRING,
    govtIdDecr: EMPTY_STRING,
    taxIdDecr: EMPTY_STRING,
};

export interface GetCustomerResponse {
    globalCustomerId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleInitial?: string | null;
    coworker?: string | null;
    suffix?: string | null;
    salutation?: string | null;
    taxId?: string | null;
    taxIdEnc?: string | null;
    dateOfBirth?: string | null;
    dateOfBirthEnc?: string | null;
    governmentId?: string | null;
    governmentIdEnc?: string | null;
    governmentIdType?: string | null;
    governmentIdIssuedState?: string | null;
    emailAddress?: string | null;
    verified?: string | null;
    verifiedDate?: string | null;
    federalTaxId?: string | null;
    taxExemptStatus?: string | null;
    submittedDate?: string | null;
    paymentReminderCallsAllowed?: string | null;
    preferredContactMethod?: string | null;
    textSolicitationAllowed?: string | null;
    printReceiptMethod?: string | null;
    preferredLanguage?: string | null;
    phoneSolicitationAllowed?: string | null;
    mailSolicitationAllowed?: string | null;
    emailSolicitationAllowed?: string | null;
    customerRoutes?: CustomerRoutes | null;
    addresses?: any;

    [key: string]: any;
}

export interface CustomerRoutes {
    customerRouteId?: string | null;
    storeRouteId?: string | null;
    storeId?: string | null;
    storeNumber?: string | null;
    routeCode?: string | null;
    routeCodeDesc?: string | null;
    [key: string]: any;
}